import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Zoom from "@material-ui/core/Zoom";
import { makeStyles } from "@material-ui/core/styles";
import ApiClient from "utils/ApiClient";
// import useCalEmbed from "./useCalEmbed";

const useStyles = makeStyles((theme) => ({
  "@global": {
    ".cal-embed-styles": {
        zIndex: "9999 !important",
        pointerEvents: "auto !important"
    },
    "[data-cal-popup]": {
        zIndex: "9999 !important",
    }
  },
  dialogRoot: {
    zIndex: 1300, 
  },
  dialogPaper: {
    borderRadius: 16,
    padding: 0,
    maxWidth: 512,
    width: "100%",
    position: "relative",
    animation: "$slideUp 0.4s ease-out forwards",
  },
  "@keyframes slideUp": {
    from: { transform: "translateY(20px)", opacity: 0 },
    to: { transform: "translateY(0)", opacity: 1 },
  },
  backDrop: {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(0,0,0,0.6)",
  },
  closeButtonContainer: {
    position: "absolute",
    right: 16,
    top: 16,
    zIndex: 10,
  },
  contentContainer: {
    padding: "2rem",
    textAlign: "center",
  },
  heading: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "1rem",
    "@media (min-width: 600px)": {
      fontSize: "1.875rem",
    },
  },
  bodyText: {
    color: "#4b5563",
    marginBottom: "2rem",
    fontSize: "1rem",
    lineHeight: "1.5",
  },
  bookButton: {
    width: "100%",
    backgroundColor: "#2563eb",
    color: "white",
    fontWeight: "bold",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.5rem",
    fontSize: "1.125rem",
    textTransform: "none",
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": {
      backgroundColor: "#1d4ed8",
      transform: "scale(1.02)",
    },
    "&:focus": {
      outline: "none",
      boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.3)",
    },
    transition: "all 0.3s ease-in-out",
  },
  dismissLink: {
    fontSize: "0.875rem",
    color: "#6b7280",
    marginTop: "1rem",
    display: "block",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      color: "#1f2937",
    },
    transition: "color 0.2s",
  },
}));

function ScheduleCall({ open, onClose, handleScheduleCallCloseAll, onBoardingStore }) {
  const classes = useStyles();

  // useCalEmbed(open, handleScheduleCallCloseAll);
  const handleDismiss = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      TransitionComponent={Zoom}
      classes={{
        paper: classes.dialogPaper,
        root: classes.dialogRoot,
      }}
      BackdropProps={{
          className: classes.backDrop
      }}
      fullWidth
      maxWidth="sm"
      disableEnforceFocus
      keepMounted={false}
    >
      <div className={classes.closeButtonContainer}>
        <IconButton
          onClick={handleDismiss}
          size="small"
          aria-label="Close modal"
        >
          <CloseOutlinedIcon style={{ color: "#9ca3af" }} />
        </IconButton>
      </div>

      <DialogContent className={classes.contentContainer}>
        <Typography variant="h2" className={classes.heading}>
          Need Support to Automate Your Workflows?
        </Typography>
        <Typography variant="body1" className={classes.bodyText}>
          Book a quick call with our specialists. We'll discuss your needs, show
          you how TigerSheet works, and guide you in building the right
          workflows for your business.
        </Typography>

        <button
          type="button"
          data-cal-link="pandiri-auphees-juq3kz/20-min-meeting"
          data-cal-config='{"theme":"light","layout":"month_view"}'
          className={classes.bookButton}
        >
          Book Your Onboarding Call Now
        </button>

        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            handleDismiss();
          }}
          className={classes.dismissLink}
        >
          No, thanks. I'll explore on my own.
        </a>
      </DialogContent>
    </Dialog>
  );
}

export default inject(({ store }) => {
  return {
    onBoardingStore: store.onBoardingStore,
  };
})(observer(ScheduleCall));


